import $ from 'jquery';
import '../vendor/slick-carousel/slick.fix';

const defaults = {
  speed: 500,
  slide: '.views-row',
  wrapper: '.view-content',
  dots: true,
  arrows: false,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [{
    breakpoint: 1024,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '20px',
    },
  }, {
    breakpoint: 640,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '0',
    },
  }],
};

/**
 * Slider Constructor
 */
function StatsSlider(element, options) {
  this.element = element;
  this.$element = $(element);
  this.settings = { ...defaults, ...options };
  this.wrapper = this.settings.wrapper;
  this.slider = this.build();
  this.ready();
}

StatsSlider.prototype = {
  build() {
    const built = (this.wrapper)
      ? this.$element.find(this.wrapper).slick(this.settings)
      : this.$element.slick(this.settings);
    return built;
  },
  ready() {
    this.$element.addClass('ready');
  },
};

export default StatsSlider;



// WEBPACK FOOTER //
// ./Slider.js